import { catchError, filter, of, switchMap } from 'rxjs';
import { ofType } from 'redux-observable';
import eventTrackingSlice from './slices';
import { postCommunityLogger$, postPlanLogger$, postSpecLogger$ } from '../apis/postEvents';

const actions = eventTrackingSlice.actions;

export const getPlanLoggerEpic = (action$) =>
  action$.pipe(
    ofType(actions.trackingEvent.type),
    filter((action) => action?.payload?.parameters?.type === 'plan'),
    switchMap((action) =>
      postPlanLogger$(action.payload.parameters).pipe(
        switchMap(() => of(actions.trackingEventFulfilled())),
        catchError((err) => of(actions.trackingEventError(err)))
      )
    )
  );

export const getSpecLoggerEpic = (action$) =>
  action$.pipe(
    ofType(actions.trackingEvent.type),
    filter((action) => action?.payload?.parameters?.type === 'spec'),
    switchMap((action) =>
      postSpecLogger$(action.payload.parameters).pipe(
        switchMap(() => of(actions.trackingEventFulfilled())),
        catchError((err) => of(actions.trackingEventError(err)))
      )
    )
  );

  export const getCommunityLoggerEpic = (action$) =>
  action$.pipe(
    ofType(actions.trackingEvent.type),
    filter((action) => action?.payload?.parameters?.type === 'community' ||
    action?.payload?.parameters?.type === 'buildeablePlan'),
    switchMap((action) =>
      postCommunityLogger$(action.payload.parameters).pipe(
        switchMap(() => of(actions.trackingEventFulfilled())),
        catchError((err) => of(actions.trackingEventError(err)))
      )
    )
  );